export default class Form
{
	constructor(el)
	{
		this.el = el;
	}

	getActionUrl()
	{
		return this.el.getAttribute("action");
	}

	getData()
	{
		let data = {};
		for (let param of new FormData(this.el)) {
			data[param[0]] = param[1];
		}

		return data;
	}
}
